import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

/** Catch-all error boundary — shows crash details instead of blank screen */
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Pulse crashed:", error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: "2rem", background: "#0a0a0f", color: "#f87171", minHeight: "100vh", fontFamily: "monospace" }}>
          <h1 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "#fff" }}>Pulse crashed</h1>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: "0.875rem", color: "#fca5a5" }}>
            {this.state.error.message}
          </pre>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: "0.75rem", color: "#6b7280", marginTop: "1rem" }}>
            {this.state.error.stack}
          </pre>
          <button
            onClick={() => { this.setState({ error: null }); window.location.reload() }}
            style={{ marginTop: "1rem", padding: "0.5rem 1rem", background: "#6366f1", color: "#fff", border: "none", borderRadius: "0.375rem", cursor: "pointer" }}
          >
            Reload
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
)
